import { axiosAPI } from "./axiosClient"
import { UserService } from './UserService';

import qs from "qs";
import { getParams } from '../helper/Helper'

export const AnalyseService = {

  getAnalyses(folderId, params, APIUrl, format) {

    let responseType = ""
    if (format == "pdf") {
      responseType = "blob"
    }
    if (format == "xls") {
      responseType = "arraybuffer"
    }

    return axiosAPI.get(`/${folderId}/${APIUrl}${format ? ('/' + format) : ''}?${getParams(params)}`, { responseType: responseType })
  },

  

  /*   getFacture(folderId, factureId, format) {
      return axiosAPI.get(`/${folderId}/editions/factures/${factureId}?lookup=true&format=${format}`, { responseType: 'blob' })
    },
  
    getFactures(folderId, params) {
      return axiosAPI.get(`/${folderId}/editions/factures?format=pdf&${getParams(params)}`, { responseType: 'blob' })
    },
  
    getProforma(folderId, proformaId, format) {
      return axiosAPI.get(`/${folderId}/editions/proformas/${proformaId}?lookup=true&format=${format}`, { responseType: 'blob' })
    }, */


}